module.exports = __webpack_public_path__ + "img/img_left_nav_bank.44eba42c.svg";